import React, { useEffect, useState } from "react";
import { Route } from "react-router-dom/cjs/react-router-dom.min";
import SEO from "../Seo";
import { ToastContainer, toast } from "react-toastify";
import LeftSidebar from "./LeftSidebar";
import TopHeader from "./TopHeader";
import { thirdparty } from "../..";

const setSSLConfig = () => {
  const [formData, setFormData] = useState({
    env_type: "",
    sandbox_api_url: "",
    sandbox_store_id: "",
    sandbox_store_password: "",
    production_api_url: "",
    production_store_id: "",
    production_store_password: "",
  });

  const fetchData = async (e) => {
    try {
      const response = await thirdparty.get("/ssl_commerz_config/1");
      if (response.status === 200) {
        setFormData(...formData, response.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // return;
      const response = await thirdparty.put("/ssl_commerz_config/1", formData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (response.status === 200) {
        toast.success("Data updated successfully!", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
      }
      
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="fixed-left">
      <SEO
        title="SSL-Commerz Configuration "
        description="SSL-Commerz Configuration - United Hospital"
        pathSlug="/admin/set_ssl_commerz"
        keywords="SSL-Commerz Configuration"
      />
      <div id="wrapper">
        <Route component={LeftSidebar} />
        <div className="content-page">
          <div className="content">
            <Route component={TopHeader} />
            <div className="page-content-wrapper">
              <div className="col-lg-10">
                <div className="card m-b-20">
                  <div className="card-body">
                    <form
                      id="adddepartmentform"
                      className="needs-validation"
                      noValidate
                      onSubmit={handleSubmit}
                    >
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label>Environment</label>
                            <select
                              className="form-control"
                              name="env_type"
                              id="env_type"
                              value={formData.env_type}
                              onChange={handleChange}
                            >
                              <option value="">Select Environment</option>
                              <option value="sandbox">Sandbox</option>
                              <option value="production">Production</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label>Sandbox URL</label>
                            <input
                              type="text"
                              className="form-control"
                              name="sandbox_api_url"
                              id="sandbox_api_url"
                              value={formData.sandbox_api_url}
                              onChange={handleChange}
                              required
                              placeholder="Sandbox URL"
                            />
                          </div>
                          <div className="form-group">
                            <label>Sandbox Store ID</label>
                            <input
                              type="text"
                              className="form-control"
                              name="sandbox_store_id"
                              id="sandbox_store_id"
                              value={formData.sandbox_store_id}
                              onChange={handleChange}
                              required
                              placeholder="Sandbox Store Id"
                            />
                          </div>
                          <div className="form-group">
                            <label>Sandbox Store Password</label>
                            <input
                              type="text"
                              className="form-control"
                              name="sandbox_store_password"
                              id="sandbox_store_password"
                              value={formData.sandbox_store_password}
                              onChange={handleChange}
                              required
                              placeholder="Sandbox Store Password"
                            />
                          </div>
                        </div>

                        <div className="col-sm-6">
                          <div className="form-group">
                            <label>Production URL</label>
                            <input
                              type="text"
                              className="form-control"
                              name="production_api_url"
                              id="production_api_url"
                              value={formData.production_api_url}
                              onChange={handleChange}
                              required
                              placeholder="Production URL"
                            />
                          </div>
                          <div className="form-group">
                            <label>Production Store ID</label>
                            <input
                              type="text"
                              className="form-control"
                              name="production_store_id"
                              id="production_store_id"
                              value={formData.production_store_id}
                              onChange={handleChange}
                              required
                              placeholder="Production Store Id"
                            />
                          </div>
                          <div className="form-group">
                            <label>Production Store Password</label>
                            <input
                              type="text"
                              className="form-control"
                              name="production_store_password"
                              id="production_store_password"
                              value={formData.production_store_password}
                              onChange={handleChange}
                              required
                              placeholder="Production Store Password"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="form-group float-right">
                        <div>
                          <button
                            type="submit"
                            className="btn waves-effect waves-light"
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer autoClose={5000} />
    </div>
  );
};

export default setSSLConfig;



// WEBPACK FOOTER //
// ./src/component/admin/setSSLConfig.js